module.exports = {
	"name": "chatbot-dashboard",
	"version": "1.35.0",
	"description": "A admin dashboard for chatbot application.",
	"engines": {
		"npm": ">=3"
	},
	"scripts": {
		"preinstall": "node tools/nodeVersionCheck.js",
		"start-message": "babel-node tools/startMessage.js",
		"prestart": "npm run start-message",
		"start": "concurrently -k -r -s first \"npm run test:watch\" \"npm run open:src\" \"npm run lint:watch\"",
		"open:src": "babel-node tools/srcServer.js",
		"open:dist": "babel-node tools/distServer.js",
		"lint": "esw webpack.config.* src tools --color",
		"lint:watch": "npm run lint -- --watch",
		"clean-dist": "npm run remove-dist && mkdir dist",
		"remove-dist": "rimraf ./dist",
		"prebuild": "npm run lint && npm run test && npm run clean-dist",
		"build": "babel-node tools/build.js && npm run open:dist",
		"just-build-serve": "babel-node tools/build.js",
		"just-build-surge": "babel-node tools/build.js && cp ./dist/index.html ./dist/200.html && surge",
		"test": "jest",
		"test:CI": "babel-node tools/testCi.js",
		"test:cover": "npm run test -- --coverage ",
		"test:cover:CI": "npm run test:CI -- --coverage && cat ./coverage/lcov.info | node_modules/coveralls/bin/coveralls.js",
		"test:watch": "jest --watch",
		"open:cover": "npm run test:cover && opn ./coverage/lcov-report/index.html",
		"analyze-bundle": "babel-node ./tools/analyzeBundle.js",
		"commit": "git-cz",
		"release": "standard-version"
	},
	"author": "vivek vaibhav",
	"license": "MIT",
	"dependencies": {
		"@antv/data-set": "0.10.2",
		"@nivo/circle-packing": "0.61.0",
		"@sentry/browser": "5.15.5",
		"antd": "3.13.1",
		"axios": "0.18.0",
		"bizcharts": "3.5.8",
		"circlepack-chart": "1.3.2",
		"classnames": "2.2.5",
		"codemirror": "5.52.2",
		"dot-prop-immutable": "1.4.0",
		"jspdf": "2.3.0",
		"lodash": "4.17.10",
		"memoize-one": "5.1.1",
		"message-types": "^2.1.0",
		"moment": "2.22.1",
		"object-assign": "4.1.0",
		"push.js": "1.0.12",
		"query-string": "6.2.0",
		"react": "16.8.6",
		"react-codemirror2": "7.1.0",
		"react-d3-tree": "1.10.6",
		"react-dom": "16.8.6",
		"react-flow-diagram": "2.13.0",
		"react-ga": "2.4.1",
		"react-icons": "2.2.7",
		"react-infinite-scroll-component": "4.1.0",
		"react-jsonschema-form": "1.0.3",
		"react-moment": "0.7.0",
		"react-quill": "1.3.5",
		"react-redux": "5.0.5",
		"react-router-dom": "4.2.2",
		"react-router-redux": "5.0.0-alpha.8",
		"react-wordcloud": "1.2.7",
		"redux": "3.6.0",
		"redux-thunk": "2.1.0",
		"reselect": "4.0.0",
		"socket.io-client": "2.3.0",
		"string-format": "2.0.0",
		"validator": "11.1.0"
	},
	"devDependencies": {
		"autoprefixer": "7.1.4",
		"babel-cli": "6.24.1",
		"babel-core": "6.25.0",
		"babel-eslint": "7.2.3",
		"babel-jest": "20.0.3",
		"babel-loader": "7.1.1",
		"babel-plugin-import": "1.7.0",
		"babel-plugin-transform-react-constant-elements": "6.23.0",
		"babel-plugin-transform-react-remove-prop-types": "0.4.6",
		"babel-polyfill": "6.23.0",
		"babel-preset-env": "1.6.0",
		"babel-preset-react": "6.24.1",
		"babel-preset-react-hmre": "1.1.1",
		"babel-preset-stage-1": "6.24.1",
		"browser-sync": "2.26.3",
		"chalk": "2.0.1",
		"commitizen": "4.0.4",
		"concurrently": "3.5.0",
		"connect-history-api-fallback": "1.3.0",
		"copy-webpack-plugin": "4.0.1",
		"coveralls": "2.13.1",
		"css-loader": "0.28.7",
		"cz-conventional-changelog": "3.1.0",
		"dotenv": "10.0.0",
		"enzyme": "3.0.0",
		"enzyme-adapter-react-16": "1.0.0",
		"eslint": "4.2.0",
		"eslint-plugin-import": "2.7.0",
		"eslint-plugin-react": "7.3.0",
		"eslint-watch": "3.1.2",
		"extract-text-webpack-plugin": "3.0.1",
		"file-loader": "0.11.2",
		"history": "4.6.0",
		"html-webpack-plugin": "2.29.0",
		"identity-obj-proxy": "3.0.0",
		"jest": "20.0.4",
		"jest-cli": "20.0.4",
		"json-loader": "0.5.4",
		"less": "3.9.0",
		"less-loader": "4.1.0",
		"mockdate": "2.0.1",
		"node": "8.9.4",
		"node-sass": "4.5.3",
		"opn-cli": "3.1.0",
		"postcss-loader": "2.0.6",
		"prompt": "1.0.0",
		"prop-types": "15.5.10",
		"raf": "3.3.2",
		"react-hot-loader": "3.0.0-beta.6",
		"react-test-renderer": "16.0.0",
		"redux-immutable-state-invariant": "2.0.0",
		"redux-mock-store": "1.3.0",
		"replace": "0.3.0",
		"rimraf": "2.6.1",
		"sass-loader": "6.0.6",
		"standard-version": "7.1.0",
		"style-loader": "0.19.0",
		"sw-precache-webpack-plugin": "1.0.0",
		"url-loader": "0.5.9",
		"webpack": "3.1.0",
		"webpack-bundle-analyzer": "2.8.2",
		"webpack-dev-middleware": "1.11.0",
		"webpack-hot-middleware": "2.18.2",
		"webpack-manifest-plugin": "2.2.0",
		"webpack-md5-hash": "0.0.5"
	},
	"keywords": [],
	"repository": {
		"type": "git",
		"url": ""
	},
	"jest": {
		"moduleNameMapper": {
			"\\.(jpg|jpeg|png|gif|eot|otf|webp|svg|ttf|woff|woff2|mp4|webm|wav|mp3|m4a|aac|oga)$": "<rootDir>/tools/assetsTransformer.js",
			"\\.(css)$": "<rootDir>/tools/assetsTransformer.js"
		},
		"setupFiles": [
			"raf/polyfill",
			"./tools/enzymeTestAdapterSetup.js"
		]
	},
	"babel": {
		"env": {
			"development": {
				"presets": [
					"env",
					"react",
					"react-hmre",
					"stage-1"
				]
			},
			"production": {
				"presets": [
					[
						"env",
						{
							"es2015": {
								"modules": false
							},
							"targets": {
								"ie": 9,
								"uglify": true
							}
						}
					],
					"react",
					"stage-1"
				],
				"plugins": [
					"transform-react-constant-elements",
					"transform-react-remove-prop-types"
				]
			},
			"test": {
				"presets": [
					"env",
					"react",
					"stage-1"
				]
			}
		}
	},
	"eslintConfig": {
		"root": true,
		"extends": [
			"eslint:recommended",
			"plugin:import/errors",
			"plugin:import/warnings",
			"plugin:react/recommended"
		],
		"plugins": [
			"react"
		],
		"parser": "babel-eslint",
		"parserOptions": {
			"ecmaVersion": 6,
			"sourceType": "module",
			"ecmaFeatures": {
				"jsx": true,
				"experimentalObjectRestSpread": true
			}
		},
		"env": {
			"es6": true,
			"browser": true,
			"node": true,
			"jquery": true,
			"jest": true
		},
		"globals": {}
	},
	"config": {
		"commitizen": {
			"path": "./node_modules/cz-conventional-changelog"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 2339
// module chunks = 13